import React, { useEffect, useRef } from "react";
import user1 from "../../assets/online/testimonials-1.jpg";
import user3 from "../../assets/online/testimonials-2.jpg";
import user2 from "../../assets/online/testimonials-3.jpg";
import OnlineTestimonialsCarousel from "./OnlineTestimonialsCarousel";
import useFreeTrial from "../../hooks/useFreeTrial";

export default function LandingOnlineTestimonials() {
  const { handleFreeTrial } = useFreeTrial();


  const cardsList = [
    {
      userImg: user1,
      userName: "Cecilia Vargas",
      userCity: "Ciudad de México",
      cardHeight: "440px",
      testimonial:
        `"A los ojos de los demás puede no tener un cambio importante, pero a mí me ha hecho sentir mejor, me ayudó a retomar la rutina, sentirme más fuerte y sobre todo, sentirme mejor conmigo misma."`,
    },
    {
      userImg: user2,
      userName: "Katya Cardenas",
      userCity: "Monterrey",
      cardHeight: "510px",
      testimonial:
        `"Empecé en The Body Method cuando vivía en Monterrey, justo antes de la pandemia. Ahora, viviendo en Washington, sigo las clases en línea con mucha disciplina. Hago 5 clases por semana y me siento fuerte, feliz y llena de energía. ¡Incluso mi novio se une a veces! Retomé TBM por mi salud y porque me caso en octubre. Llevo casi tres meses con TBM Online y los resultados son increíbles."`,
    },
    {
      userImg: user3,
      userName: "Karen Rodriguez",
      userCity: "Guadalajara",
      cardHeight: "440px",
      testimonial:
        `"Conocí The Body Method desde su inauguración. Después de mi clase de prueba, me inscribí de inmediato. He probado muchos ejercicios, pero ninguno me ha funcionado como TBM. En ningún lugar he logrado tonificarme tan rápido y divertirme tanto. Soy la más feliz de haber conocido este método mágico guiada por las mejores coaches."`,
    },
    {
      userImg: user1,
      userName: "Mariana Ortiz",
      userCity: "Puebla",
      cardHeight: "460px",
      testimonial:
        `"Llevaba años sin encontrar un entrenamiento que no se sintiera castigo. TBM Online me encaja con mi jornada laboral: entreno a la hora que puedo y siento que progreso de verdad. Las coaches explican cada movimiento; por fin entiendo el cuerpo que estoy fortaleciendo."`,
    },
    {
      userImg: user2,
      userName: "Luisa Fernández",
      userCity: "Mérida",
      cardHeight: "430px",
      testimonial:
        `"Lo que más valoro es la constancia y la energía de las clases. Después de dos hijos, pensé que volver a sentirme ágil sería imposible. TBM me devolvió confianza, mejor sueño y ganas de moverme todos los días."`,
    },
    {
      userImg: user3,
      userName: "Andrea Soto",
      userCity: "Querétaro",
      cardHeight: "480px",
      testimonial:
        `"Probé gimnasios y apps, pero nada se compara con la sensación de comunidad aunque sea en línea. Comento clases con mis amigas, comparamos progreso y no me pierdo: el planner y los filtros me ahorraron horas de búsqueda. Estoy en mi mejor versión a los 42 años."`,
    },
    {
      userImg: user1,
      userName: "Paola Ríos",
      userCity: "Tijuana",
      cardHeight: "450px",
      testimonial:
        `"Viajo mucho por trabajo y TBM me acompaña en el hotel o en casa. Misma calidad de clases, mismas coaches, cero excusas. En seis meses bajé tallas, pero el cambio de postura y energía fue lo que más noté."`,
    },
    {
      userImg: user2,
      userName: "Diana Estrada",
      userCity: "León",
      cardHeight: "500px",
      testimonial:
        `"Me uní por recomendación de una prima y ahora toda la familia pregunta qué hago. Me encanta la variedad de disciplinas: un día bici, al otro un flow más calmado. Nunca aburrí; cada semana tengo clases favoritas guardadas. El método es exigente pero respetuoso con el cuerpo."`,
    },
    {
      userImg: user3,
      userName: "Valeria Mena",
      userCity: "Culiacán",
      cardHeight: "440px",
      testimonial:
        `"Era de las que dejaban de ir al gimnasio a la tercera semana. Con TBM Online me enganché porque las sesiones vuelan y termino con la piel llena de endorfinas. Lo recomiendo a quien tenga miedo de empezar: aquí se empieza en serio, pero con apoyo de verdad."`,
    },
    {
      userImg: user1,
      userName: "Regina López",
      userCity: "Aguascalientes",
      cardHeight: "470px",
      testimonial:
        `"Hago TBM en las mañanas antes de despertar a los niños. Esa rutina fija me ordenó el día entero. Noté resultados en resistencia y en ánimo; mi pareja notó el cambio antes que yo, y eso me motivó a seguir."`,
    },
    {
      userImg: user2,
      userName: "Ilse Ramírez",
      userCity: "Chihuahua",
      cardHeight: "520px",
      testimonial:
        `"Después de una lesión de rodilla, tenía pánico a entrenar fuerte. Las opciones bajo impacto y la claridad de las instructuras me dieron la confianza que no encontré en fisioterapia sola. Hoy hago clases completas otra vez y mido el progreso semana a semana. Invertí en mí y fue la mejor decisión del año."`,
    },
    {
      userImg: user3,
      userName: "Fernanda Ibáñez",
      userCity: "Cancún",
      cardHeight: "455px",
      testimonial:
        `"Vivo cerca del mar y aun así prefería quedarme en el sillón. TBM me dio disciplina sin salir de casa, con clases que se sienten presenciales. Ahora hago al menos cuatro días a la semana; mi ansiedad bajó y tengo otra actitud con la comida, sin dieta extrema."`,
    },
  ]

  const containerRef = useRef(null);

  // Usamos IntersectionObserver para detectar la visibilidad
  useEffect(() => {
    const observerOptions = {
      root: null, // Usamos la ventana de visualización
      rootMargin: "0px",
      threshold: 0.3, // Al 10% del componente visible, se activa la animación
    };

    // Función para manejar la visibilidad del componente
    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.remove("opacity-0");
          entry.target.classList.add("animate-fade-in");
        }
      });
    };

    // Creamos el IntersectionObserver
    const observer = new IntersectionObserver(
      handleIntersection,
      observerOptions
    );

    // Observamos los componentes
    if (containerRef.current) observer.observe(containerRef.current);

    return () => {
      // Limpiamos el observer cuando el componente se desmonte
      if (containerRef.current) observer.unobserve(containerRef.current);
    };
  }, []);
  return (
    <div id="testimonios" className="online-testimonials bg-white d-flex flex-column align-items-center" >
      <div className="opacity-0 d-flex flex-column align-items-center w-100 h-100" ref={containerRef}>

      <h6 className="online-subtitle text-dark text-center mb-1">
        Nuestra comunidad
      </h6>
      <h2 className="online-title text-dark text-center">
        Testimonios
      </h2>

      <OnlineTestimonialsCarousel slides={cardsList} options={{
        loop: true,
        autoplay: false,
        align: "start"
      }}/>

      </div>

    </div>
  );
}
